import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import { promise } from "when";
import axios from "axios";
import BaseData from "./BaseData";

var StatementCategory =
/*#__PURE__*/
function (_BaseData) {
  _inherits(StatementCategory, _BaseData);

  function StatementCategory() {
    _classCallCheck(this, StatementCategory);

    return _possibleConstructorReturn(this, _getPrototypeOf(StatementCategory).call(this, "StatementCategory"));
  }

  return StatementCategory;
}(BaseData);

export default new StatementCategory();